module.exports = "import React from 'react';\nimport DayPickerInput from 'react-day-picker/DayPickerInput';\nimport 'react-day-picker/lib/style.css';\n\nexport default function Example() {\n  return (\n    <div>\n      <p>Please type a day:</p>\n      <DayPickerInput onDayChange={day => console.log(day)} />\n    </div>\n  );\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/code-samples/examples/input.js
// module id = 779
// module chunks = 168707334958949